import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

/**
 * Gate guards Add/Edit/Delete/Save actions for guest users.
 *
 *   const { isGuest, gate } = useGuestGate();
 *   <Button onClick={() => { if (!gate("Adding a stock")) realAdd(); }} />
 *
 * gate() returns true and shows a toast when the user is a guest (caller
 * should bail out). It returns false when the user is a full member.
 */
export function useGuestGate() {
  const { user } = useAuth();
  const isGuest = user?.role === "guest";
  const gate = (description = "This action") => {
    if (!isGuest) return false;
    toast.info(
      `${description} is only available for full members. See "Our Offer" to upgrade.`,
      { duration: 4000 }
    );
    return true;
  };
  return { isGuest, gate };
}
